import React from 'react';
import { ThirdPartyIntegrationList } from '../../../services/api';
import { useTranslation } from '../../../contexts/TranslationContext';
import './IntegrationCard.css';

interface IntegrationCardProps {
  integration: ThirdPartyIntegrationList;
  onAddToAida: (integrationId: number) => void;
  onViewDetails: (integrationId: number) => void;
}

const IntegrationCard: React.FC<IntegrationCardProps> = ({
  integration,
  onAddToAida,
  onViewDetails,
}) => {
  const { t, currentLanguage } = useTranslation();
  const handleAddClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onAddToAida(integration.id);
  };

  const handleCardClick = () => {
    onViewDetails(integration.id);
  };

  return (
    <div className="integration-card" onClick={handleCardClick}>
      <div className="integration-card-header">
        {integration.image_url ? (
          <img
            src={integration.image_url}
            alt={integration.title}
            className="integration-logo"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
            }}
          />
        ) : (
          <div className="integration-logo-placeholder">
            <span>{integration.title.charAt(0).toUpperCase()}</span>
          </div>
        )}
        
        <div className="integration-status">
          {integration.is_active ? (
            <span className="status-badge active">{t('marketplace.active')}</span>
          ) : (
            <span className="status-badge inactive">{t('marketplace.inactive')}</span>
          )}
        </div>
      </div>

      <div className="integration-card-body">
        <h3 className="integration-title">{integration.title}</h3>
        <p className="integration-description">{integration.brief_description}</p>
        
        <div className="integration-pricing">
          <span className="price">
            {integration.monthly_price} {currentLanguage === 'fa' ? 'تومان' : 'IRR'}
          </span>
          <span className="period">{t('marketplace.monthlyPrice')}</span>
        </div>
      </div>

      <div className="integration-card-footer">
        <button
          className="btn-secondary learn-more-btn"
          onClick={handleCardClick}
        >
          {t('marketplace.learnMore')}
        </button>
        
        <button
          className="btn-primary add-btn"
          onClick={handleAddClick}
          disabled={!integration.is_active}
        >
          {t('marketplace.addToAida')}
        </button>
      </div>
    </div>
  );
};

export default IntegrationCard; 